import { Component, inject } from '@angular/core';

import { NotificationService } from '../../../core/services/notification.service';

/**
 * Pila de notificaciones flotantes. Va montada una sola vez en la raíz de la
 * app; el contenido lo alimenta `NotificationService`.
 */
@Component({
  selector: 'app-notifications',
  standalone: true,
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent {
  private readonly notificationService = inject(NotificationService);

  readonly notifications = this.notificationService.notifications;

  dismiss(id: number): void {
    this.notificationService.dismiss(id);
  }
}
